module.exports = __webpack_public_path__ + "static/Attar-73f5135ddbb7ad1e327713127f13a704.jpg";